import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transactionTypePipe',
})
export class TransactionTypePipe implements PipeTransform {
  transform(transactionType: string): string {
    switch (transactionType) {
      case 'ActiveEmployees':
        return 'Aktive ansatte';
      case 'Autobank_OCR':
        return 'Autobank OCR';
      case 'Autobank_Remittering':
        return 'Autobank remittering';
      case 'EFakturaB2C':
        return 'E-Faktura B2C';
      case 'InvoicePrint':
        return 'Fakturaprint';
      case 'OcrScan':
        return 'OCR scan';
      default:
        return transactionType;
    }
  }
}
